import React from "react";
import Context from "../../../Context";
import Select from "react-select";
import Blocker from "../../Misc/Blocker";

export default class ElementShipSelect extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      pending: false,
      items: [],
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shipId !== this.props.shipId) {
      this.onSingleShip();
    }
  }

  onSingleShip = () => {
    const { items } = this.state;
    if (items.length === 1 && items[0]?.value !== this.props.shipId) {
      this.context.replace(`/element/${items[0]?.value}`);
    }
  };

  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qr("/ship/list");

    this.setState({ pending: false, items }, () => this.onSingleShip());
  };

  onChange = (shipId) => {
    this.context.redirect(`/element/${shipId}/`);
  };

  openSpec = async () => {
    const { shipId, specId } = this.props;
    if (!shipId || shipId === "any") {
      this.context.redirect("/spec/");
      return;
    }
    this.setState({ pending: true });
    let ship = await this.context.api.q("/ship/get", { id: shipId });
    if (ship) {
      if (ship.project) {
        this.context.redirect(
          `/spec/${ship.project}/`
          /* `/spec/${ship.project}/${shipId}/${
            specId && specId !== "any" ? specId : ""
          }`*/
        );
      }
    }
  };

  render() {
    const { manageSpec } = this.props;
    const select = (
      <Select
        value={this.context.api.getReferenceValue(
          this.props.shipId,
          this.state.items
        )}
        onChange={(result) => this.onChange(result.value)}
        className="from-control react-select react-select-grey"
        classNamePrefix="react-select-inner"
        options={this.state.items}
        placeholder="Выберите судно..."
        noOptionsMessage={({ inputValue }) =>
          `Ничего не найдено по запросу ${inputValue}`
        }
      />
    );
    return (
      <>
        <Blocker hAuto on={this.state.pending}>
          {manageSpec ? (
            <div className="react-select-group mb-4">
              {select}
              <div
                onClick={this.openSpec}
                title="Настройка структуры СТСиК"
                to="/spec/"
                className="btn btn-light btn-icon"
              >
                <i className="fa fa-cogs"></i>
              </div>
            </div>
          ) : (
            <>{select}</>
          )}
        </Blocker>
      </>
    );
  }
}
